module.exports = __webpack_public_path__ + "img/qyglmix.3216ed57.jpg";